import * as React from 'react';
import { cn } from '../utils';

/**
 * Pulsing placeholder box — the one skeleton style for every loading surface.
 * Size/shape via className (`h-4 w-32`, `rounded-full`, …); darker variant via
 * `dark:bg-bg-tertiary` when the placeholder sits on an already-dark card.
 * Pure div + Tailwind `animate-pulse`; deliberately not a package dependency —
 * skeleton libraries only provide this primitive anyway, never the layout.
 */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded bg-muted dark:bg-bg-quaternary', className)}
      {...props}
    />
  );
}
